const authTypesOptions = [
    {
        value: '', label: 'Нет',
    },
    {
        value: 'email', label: 'По email',
    },
    {
        value: 'guest', label: 'По имени',
    },
    {
        value: 'phone', label: 'По email + телефон',
    },
];

const participationTypesOptions = [
    {
        value: 'hybrid', label: 'Онлайн + офлайн',
    },
    {
        value: 'online', label: 'Онлайн',
    },
    {
        value: 'offline', label: 'Офлайн',
    },
];

const externalAuthServices = [
    {
        id: 'vk', label: 'Вконтакте',
    },
    // {
    //     id: 'facebook', label: 'Facebook',
    // },
    // {
    //     id: 'twitter', label: 'Twitter',
    // },
    {
        id: 'mailru', label: 'Mail.ru',
    },
    // {
    //     id: 'linkedin', label: 'LinkedIn',
    // },
    // {
    //     id: 'google', label: 'Google',
    // },
    {
        id: 'ok', label: 'Одноклассники',
    },
    {
        id: 'yandex', label: 'Яндекс',
    },
    {
        id: 'sso', label: 'SSO',
    },
];

const defaultWebHooks = [{ url: '', secretKey: '' }, { url: '', secretKey: '' }];

const webHookMethodOptions = [
    {
        value: 'GET', label: 'GET',
    },
    {
        value: 'POST', label: 'POST',
    },
    {
        value: 'PUT', label: 'PUT',
    },
    {
        value: 'PATCH', label: 'PATCH',
    },
];

const webHookDeliveryFormatOptions = [
    {
        value: 'body', label: 'BODY',
    },
    {
        value: 'json', label: 'JSON',
    },
    {
        value: 'multipart', label: 'MULTIPART',
    },
    {
        value: 'query', label: 'QUERY',
    },
    {
        value: 'form_params', label: 'FORM PARAMS',
    },
];

export {
    authTypesOptions,
    participationTypesOptions,
    externalAuthServices,
    defaultWebHooks,
    webHookMethodOptions,
    webHookDeliveryFormatOptions
};